import CompanyReports from './CompanyReports';

export default CompanyReports;
